module.exports = __webpack_public_path__ + "img/hk_24.aea127cf.png";